import { FaMapMarkedAlt, FaBorderAll, FaMagic, FaPenNib } from 'react-icons/fa';
import tourWelcome from '../assets/tour-welcome.jpg';
import tourWhatYouBuild from '../assets/tour-what-you-build.jpg';
import tourAiDrafts from '../assets/tour-ai-drafts.jpg';
import tourNextBuild from '../assets/tour-next-build.jpg';
// ─────────────────────────────────────────────────────────────────────────────
// MANAGER TOUR - the landing screen (Portal list / Challenges).
//
// THE FRAME. WHO: an Order officer who rebuilds grounds out of the memories of
// Avatars that fell on them. WHY, and there are TWO reasons, both must be said:
//   1. so the next Avatars train on that ground and last longer over there;
//   2. so we find what the fallen one MISSED - that is how the Order learns the
//      Chtonians. Rebuilding is investigation as much as it is preparation.
//
// THE CHAIN, in this order, before the word Engram is used: every Avatar carries
// an Engram across; when one falls the recording comes home; the Order reads its
// last hours out of it; that memory is the ground you edit. The terminal drafts
// from the same recording.
//
// COPY RULES. Say what a thing IS and what the reader DOES - phrasing through
// negation is banned. Plain words: if a sentence needs a second read, rewrite it.
// Short: intro cards ~40-50 words, spotlight cards ~20-30. The spotlight cards
// explain CONTROLS and stay in plain product language; the lore lives in the
// three intro cards. Missing spotlight target → centered card.
// ─────────────────────────────────────────────────────────────────────────────
export const MANAGER_TOUR = {
    id: 'manager',
    seenKey: 'vm-tutorial-seen',
    steps: [
        // ── Intro frames: what this is ──────────────────────────────────────
        {
            id: 'welcome',
            kind: 'intro',
            icon: FaMapMarkedAlt,
            image: tourWelcome,
            title: 'Welcome, Commander',
            body: "The Chtonians hold the Deep Realm. A human who crosses dies there in under two minutes, so the Orders send Avatars in our place. They die too - and what they remember comes home. You are the officer who rebuilds the ground out of those memories. Welcome to the base, Commander.",
        },
        {
            id: 'what-you-build',
            kind: 'intro',
            icon: FaBorderAll,
            image: tourWhatYouBuild,
            title: 'Where a ground comes from',
            body: 'Every Avatar carries an Engram across. When one falls, the recording comes home and the Order reads its last hours out of it. Here you rebuild that ground cell by cell - the same walk, the same obstacles - so the next Avatars train on it and last longer over there.'
        },
        {
            id: 'ai-and-flow',
            kind: 'intro',
            icon: FaMagic,
            image: tourAiDrafts,
            title: 'What they missed',
            body: "Rebuilding is also reading. Somewhere on that ground the Avatar missed something, and what it missed is what the Chtonians keep. Describe the ground and the terminal drafts it from the recording - story, obstacles, art. It saw what a dying Avatar saw, so go over every cell and find the gap.",
        },
        // ── Spotlight tour: the main screen ─────────────────────────────────
        {
            id: 'nav',
            kind: 'spotlight',
            target: '.mode-switcher',
            placement: 'bottom',
            title: 'Portals & Challenges',
            body: 'Switch between your own grounds and Challenges - set tasks where the Order fixes the rules and the exact amount of Knowledge you place.',
        },
        {
            id: 'add-level',
            kind: 'spotlight',
            target: '.create-button',
            placement: 'bottom',
            title: 'Build a new ground',
            body: 'Name it, upload its map, then fill the cells yourself or describe the ground and let the terminal draft the whole thing.',
        },
        {
            id: 'status',
            kind: 'spotlight',
            target: '.status-tabs',
            placement: 'bottom',
            title: 'Track every ground',
            body: "Filter by stage - Draft while you're building, Pending while the Order reviews it, then Approved and open for training, or Rejected with notes.",
        },
        {
            id: 'open-editor',
            kind: 'spotlight',
            target: '.item-card .primary-action',
            placement: 'auto',
            title: 'Step into the Portal',
            body: 'This opens the editor, where the ground actually takes shape. First time in, a short briefing walks you through it.',
        },
        {
            id: 'submit',
            kind: 'spotlight',
            target: '.item-card .pipeline-button',
            placement: 'auto',
            title: 'Submit for review',
            body: 'When the checklist reads green, send it up. Once the Order verifies it, Avatars train on it. Track the status right here and resubmit after any notes.',
        },
        // ── Outro: hand off to the editor tour ──────────────────────────────
        {
            id: 'next-editor',
            kind: 'intro',
            icon: FaPenNib,
            image: tourNextBuild,
            title: 'Next: into the editor',
            body: 'Open any ground - or build a new one - and a briefing walks you through writing the story, placing obstacles, and shaping each cell. You can replay any briefing from the Tutorial button up top.',
        },
    ],
};
